import { Component, inject } from '@angular/core';
import { Agent } from '@app/shared/models/agent';
import { ListViewProviderDirective, NtapGlobalConstants } from '@ntap/core';
import { first, tap } from 'rxjs';

@Component({
  selector: `app-odabir-povezanog-agenta`,
  templateUrl: './odabir-povezanog-agenta.component.html'
})
export class OdabirPovezanogAgentaComponent {
  public showDialog = false;

  private listviewProvider = inject(ListViewProviderDirective);

  public refresh() {
    this.listviewProvider.refresh();
  }

  public onSelectedItem(agenti: Agent[]) {
    let id = 0;
    this.listviewProvider.view$
      .pipe(
        first(),
        tap((view) => {
          const parentJedinicaGradivaId = (
            this.listviewProvider.viewState as {
              'en~jedinica_gradiva~id': number;
            }
          )['en~jedinica_gradiva~id'];

          agenti.forEach((agent) => {
            const newItem: any = {
              'sv~autor~id': id,
              'sv~autor~identifikator': agent['en~agent~id'],
              'sv~autor~entitet_id': parentJedinicaGradivaId,
              'en~agent~naziv': agent['en~agent~naziv']
            };

            id--;
            newItem[NtapGlobalConstants.ATTR_$itemType] = view.$mainType;
            this.listviewProvider.addItem(newItem);
            this.listviewProvider.updateItem(newItem, 0);
          });
        })
      )
      .subscribe();

    this.showDialog = false;
  }
}
